import { useEffect } from 'react';
import { Typography } from '@mui/material';
import NavBar from '../NavBar';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

export default function Temp_Signup_Redirect() {
  const location = useLocation();

  useEffect(() => {
    // Save previous body / html background so we can restore it on unmount
    const prevBodyBg = (typeof document !== 'undefined' && document.body) ? document.body.style.backgroundColor : '';
    const prevHtmlBg = (typeof document !== 'undefined' && document.documentElement) ? document.documentElement.style.backgroundColor : '';

    try {
      // scroll to top
      if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
      // force full-page black background
      if (typeof document !== 'undefined') {
        if (document.body) document.body.style.backgroundColor = '#000';
        if (document.documentElement) document.documentElement.style.backgroundColor = '#000';
      }
    } catch (e) {
      // ignore in non-browser environments
    }

    return () => {
      // restore previous values
      try {
        if (typeof document !== 'undefined') {
          if (document.body) document.body.style.backgroundColor = prevBodyBg || '';
          if (document.documentElement) document.documentElement.style.backgroundColor = prevHtmlBg || '';
        }
      } catch (e) {
        // ignore
      }
    };
  }, [location]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#000' }}>
      <NavBar />
      <main
        style={{
          flex: '1 0 auto',
          backgroundColor: '#000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 16px',
        }}
      >
        <div
          style={{
            backgroundColor: '#000',
            color: '#fff',
            padding: '36px 48px',
            borderRadius: 12,
            minWidth: 260,
            textAlign: 'center',
            boxShadow: '0 6px 24px rgba(0,0,0,0.5)',
            border: '1px solid rgba(255,255,255,0.08)'
          }}
        >
          <Typography variant="h6" component="div" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#ffffffff' }}>
            Thank you for signing up!
          </Typography>
          <Typography variant="body1" component="div" style={{ marginTop: 16, fontFamily: 'Inter, sans-serif', color: '#ccccccff' }}>
            Your account has been created successfully. Our interface is still under development but will be functional soon.
            We have your email on record and will notify you once the platform is ready to use.
          </Typography>
        </div>
      </main>
      <Footer />
    </div>
  );
}